import Model from './Model'

export default class Blog extends Model {
  resource() {
    return 'blogs'
  }
}
